/**
 * Copyright (C), 2012-2022, Sichuan Xiaoka Technology Co., Ltd.
 * 高德地图-地图JSAP部分方法
 * */
import util from "./utils";
import axios from "axios";
export default {
    /**
     * 逆地理编码
     * @param lnglat
     * @constructor
     */
    AMapReGeo(lnglat) {
        console.log('lnglat::: ', lnglat);
        if(!lnglat) {
            return new Error('lnglat参数为空');
        }
        let latitude=""
        let longitude=""
        if(Array.isArray(lnglat)){
            latitude=lnglat[1]
            longitude=lnglat[0]
        }else if(typeof lnglat==='object'){
            latitude=lnglat.lat
            longitude=lnglat.lng
        }else if(typeof lnglat==='string'){
            let arr=lnglat.split(',')
            latitude=arr[1]
            longitude=arr[0]
        }
        
        return new Promise((resolve, reject) => {
            let url = "/map/service/hero/geocode/regeo";
            let params = {
                appKey: "LeuNTRDQxXYXp6SVSWrCbC7xliXWu81Y",
                latitude: latitude,
                longitude: longitude,
                timestamp: new Date().getTime(),
                uuid: util.uuid(),
            }
            const signature = util.RSA_SIGN(JSON.stringify(params))
            axios.post(url, {encryption: util.AesEncryptFn(JSON.stringify(params), 'EJEmsx62SADnVlq2', '0109085465466790')}, {
                headers: {
                    'X-Request-Sign': signature
                },
            }).then(response => {
                const {data, code} = response
                if (code === 0) {
                    resolve(data);
                } else {
                    resolve(data);
                }
            }).catch(reason => {
                reject(reason);
            });
        }).catch(function (reason) {
            return reason;
        });
        // let geocoder = new AMap.Geocoder();
        // return new Promise(function (resolve, reject) {
        //     geocoder.getAddress(lnglat, function (status, result) {
        //         if (status === "complete" && result.info === "OK") {
        //             resolve(result);
        //         } else {
        //             reject(result);
        //         }
        //     });
        // }).catch(function (reason) {
        //     return reason;
        // });
    },
    /**
     * 地理编码
     * @param address
     * @constructor
     */
    AMapGeo(address) {
        let geocoder = new AMap.Geocoder();
        return new Promise(function (resolve, reject) {
            geocoder.getLocation(address, (status, result) => {
                if (status === "complete" && result.info === "OK") {
                    resolve(result);
                } else {
                    reject(result);
                }
            });
        }).catch(function (reason) {
            return reason;
        });
    },
    /**
     * 输入提示，根据输入关键字提示匹配信息
     * @param keyword
     * @param type
     * @param city
     * @param datatype
     * @param citylimit
     * @returns {Promise<void>}
     * @constructor
     */
    async AMapAutocomplete({keyword, type, city, datatype, citylimit}) {
        let autocomplete = new AMap.Autocomplete({
            type: type,
            city: city,
            datatype: datatype || "all",
            citylimit: citylimit || false,
        });
        if (keyword == "") return;
        return new Promise((resolve) => {
            if (keyword) {
                autocomplete.search(keyword, function (status, res) {
                    if (status === "complete") {
                        resolve({
                            code: 1,
                            data: res,
                        });
                    } else {
                        resolve({
                            code: 0,
                        });
                    }
                    autocomplete = null;
                });
            }
        });
    },
    /**
     * 路线规划
     * @returns {Promise<void>}
     * @constructor
     */
    AMapDriving(start, end, policy = 10) {
        const driving = new AMap.Driving({
            extensions:'all',
            // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式
            policy: policy
        })
        console.log(driving);
        return new Promise((resolve) => {
            driving.search(start, end, (status, res) => {
                if (status === "complete") {
                    console.log(res);
                    const paths = res.routes
                    paths.sort((a, b) => Number(a.distance) - Number(b.distance));
                    // 距离相等的多个路段
                    let pathArr = paths.filter(
                        (item) => item.distance === paths[0].distance
                    );

                    if (pathArr.length > 1) {
                        pathArr.sort((a, b) => Number(a.duration) - Number(b.duration));
                        pathArr = pathArr.filter(
                            (item) => item.duration === pathArr[0].duration
                        );
                        if (pathArr.length > 1) {
                            // 路段长度的多个路段
                            pathArr.sort((a, b) => a.steps.length - b.steps.length);
                        }
                    }
                    resolve({
                        code: 1,
                        data: pathArr.length && pathArr[0]
                    });
                } else {
                    resolve({
                        code: 0,
                    });
                }
                // 未出错时，result即是对应的路线规划方案
            })
        });
    },


    /**
     * 地点搜索服务
     * @param keyword 关键字
     * @param city 城市名（中文或中文全拼）、citycode、adcode
     * @param citylimit true：强制限制设定城市，false：不强制限制设定城市
     * @param pageSize 单页显示结果条数
     * @param pageIndex 页码
     * @param extensions 此项默认值：base，返回基本地址信息 取值：all，返回基本+详细信息
     * @param {LngLat} center 根据中心点经纬度、半径以及关键字进行周边查询
     * @param radius 根据中心点经纬度、半径以及关键字进行周边查询 radius取值范围：0-50000
     * @returns {Promise<void>}
     * @constructor
     */
    AMapPlaceSearch({keyword, type, city, extensions, citylimit, center}) {
        let placeSearch = new AMap.PlaceSearch({
            type: type,
            city: city,
            extensions: extensions || "all",
            citylimit: citylimit || false,
        });
        if (keyword == "") return;
        return new Promise((resolve) => {
            if (keyword) {
                placeSearch.search(keyword, function (status, res) {
                    if (status === "complete") {
                        resolve({
                            code: 1,
                            data: res.poiList.pois,
                        });
                    } else {
                        resolve({
                            code: 0,
                        });
                    }
                    placeSearch = null;
                });
            } else if (center) {
                placeSearch.searchNearBy("", center, 200, function (status, res) {
                    if (status === "complete") {
                        resolve({
                            code: 1,
                            data: res.poiList.pois,
                        });
                    } else {
                        resolve({
                            code: 0,
                        });
                    }
                    placeSearch = null;
                });
            }
        });
    },
};
